import { NgModule } from '@angular/core';
import { IfIsBrowserDirective, IfIsServerDirective } from './if-is-directive';

@NgModule({
  declarations: [IfIsServerDirective, IfIsBrowserDirective],
  exports: [IfIsServerDirective, IfIsBrowserDirective],
})
export class DirectivesModule {}
